/**
 * Created by rathompson on 9/28/21
 * File: RoleRenderer
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { useContext } from 'react'
import { Body } from '@panwds/react-ui'
import { OBJECT } from '../../../../../common/utils/Utils'
import { getVarValue } from '../../../../../common/utils/Sparky'
import { FF_ROLES_ENABLED } from '../../../../../common/utils/FeatureFlags'
import { LABEL_SUPERUSER } from '../../../../constants/LabelConstants'
import GlobalContext from '../../../../../common/context/GlobalContext'

const rolesEnabled = getVarValue(FF_ROLES_ENABLED, false)

/**
 *   Identity role table cell
 */
const RoleRenderer = ({ row, value }) => {
  const { iamReducer = {} } = useContext(GlobalContext)
  const { roleMap = {}, customRoleMap = {} } = iamReducer

  if (!rolesEnabled) {
    return (<Body size="lg" addClassName='tw-truncate'>{LABEL_SUPERUSER}</Body>)
  }
  return (
    <div className='tw-flex tw-flex-col tw-gap-0.5 tw-h-full tw-w-full tw-p-1'>
      {OBJECT.hasObject(row?.original?.roles) && Object.entries(row?.original?.roles).sort().map(([app_id, policies]) => {
        return policies?.map(({ role }, index) => (
          <div key={index} className='tw-flex-1 tw-flex'>
            <Body size="lg" addClassName='tw-truncate'>{customRoleMap[role]?.label || customRoleMap[role]?.name || roleMap[role]?.label || role}</Body>
          </div>
        ))
      })}
    </div>
  )
}

RoleRenderer.propTypes = {}
export default RoleRenderer
